<template>
  <lucide-icon
    v-if="operator"
    class="condition-operator-icon"
    width="24"
    height="24"
    :name="icons[operator]"
  />
</template>

<script setup lang="ts">
import LucideIcon from "@core/ui/LucideIcon.vue";

import type { IconName } from "@core/ui/lucideIcons";
import type { ConditionOperator } from "./ConditionItem";

defineProps<{
  operator: ConditionOperator | null;
}>();

const icons: { [p in ConditionOperator]: IconName } = {
  "=": "equal",
  "!=": "equal-not",
  ">": "chevron-right",
  "<": "chevron-left",
  ">=": "equal-greater",
  "<=": "equal-less",
  "?": "check",
  "!": "x"
};
</script>

<style lang="scss">
.condition-operator-icon {
  width: 16px;
  height: 16px;
  margin-top: 0;
  flex-shrink: 0;
  max-height: 16px;
  max-width: 16px;
}
</style>
